/** Minimal typed pub/sub, avoids pulling in Node's EventEmitter for a browser-only SDK. */
export class Emitter<EventMap extends Record<string, unknown>> {
  private listeners = new Map<keyof EventMap, Set<(payload: never) => void>>();

  on<K extends keyof EventMap>(event: K, cb: (payload: EventMap[K]) => void): () => void {
    let set = this.listeners.get(event);
    if (!set) {
      set = new Set();
      this.listeners.set(event, set);
    }
    set.add(cb as (payload: never) => void);
    return () => set!.delete(cb as (payload: never) => void);
  }

  off<K extends keyof EventMap>(event: K, cb: (payload: EventMap[K]) => void): void {
    this.listeners.get(event)?.delete(cb as (payload: never) => void);
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
    this.listeners.get(event)?.forEach((cb) => (cb as (payload: EventMap[K]) => void)(payload));
  }

  clear(): void {
    this.listeners.clear();
  }
}
